export default __webpack_public_path__ + "static/bnr-usedcar-926db71a89b8b14a7ee30908fcd6e064.png";